export const namespace = 'station';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const ACTION_TYPES = {
  GET_STATION: `${namespace}/GET_STATION`,
  SET_STATION: `${namespace}/SET_STATION`,
  SET_STATUS: `${namespace}/SET_STATUS`
};

export const getStation = () => ({
  type: ACTION_TYPES.GET_STATION
});

export const setStation = data => ({
  type: ACTION_TYPES.SET_STATION,
  payload: {
    data
  }
});

export const setStatus = status => ({
  type: ACTION_TYPES.SET_STATUS,
  payload: {
    status
  }
})
